import api from '../utils/api';

const BASE = '/api/saved-scenarios';

/**
 * Get all scenarios saved by the current user.
 * @route GET /api/saved-scenarios
 * @param {Object} params
 * @returns {Promise<Object>} Saved scenarios and pagination information
 */
export const getSavedScenarios = (params = {}) => 
    api.get(BASE, { params }).then((response) => ({ // Transform the SavedScenario response into the format expected by ScenarioCarousel to reuse the existing carousel
        scenarios: Array.isArray(response.data)     
            ? response.data
                .map((savedRecord) => savedRecord.scenario)
                .filter(Boolean)
            : [],
        hasMore: false
    }));

/**
 * Save a scenario for the current user.
 *
 * @route POST /api/saved-scenarios/:scenarioId
 * @param {string} scenarioId
 * @returns {Promise<Object>} Updated scenario and user save counts
 */
export const saveScenario = (scenarioId) =>
    api.post(`${BASE}/${scenarioId}`).then((response) => response.data);

/**
 * Remove a scenario from the current user's saved scenarios.
 *
 * @route DELETE /api/saved-scenarios/:scenarioId
 * @param {string} scenarioId
 * @returns {Promise<Object>} Updated scenario and user save counts
 */
export const unsaveScenario = (scenarioId) =>
    api.delete(`${BASE}/${scenarioId}`).then((response) => response.data);